"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueWrapper = exports.ShortMultiDisplay = exports.SelectContainer = exports.MultiValueChipCloseIcon = exports.MultiValueChip = exports.OptionCheckboxLayer = exports.OptionWrapper = exports.IconLeftWrapper = exports.CloseIcon = exports.CheckboxWrapper = exports.AvatarIcon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CloseIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseIcon"));

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin-top: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.lineHeight;
}, function (_ref4) {
  var theme = _ref4.theme,
      hasLabel = _ref4.hasLabel;
  return hasLabel ? theme.marginTop : '0';
});

exports.SelectContainer = SelectContainer;

var IconLeftWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  height: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.iconPaddingRight);
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.iconHeight);
});

exports.IconLeftWrapper = IconLeftWrapper;
var CloseIcon = (0, _styledComponents["default"])(_CloseIcon["default"])(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  &:hover {\n    fill: ", ";\n  }\n"])), function (_ref7) {
  var isFocused = _ref7.isFocused,
      theme = _ref7.theme;
  return isFocused ? theme.clearIconFocusedHoverColor : theme.clearIconHoverColor;
});
exports.CloseIcon = CloseIcon;

var AvatarIcon = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.avatarPaddingRight);
});

exports.AvatarIcon = AvatarIcon;

var CheckboxWrapper = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  width: 100%;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return "".concat(theme.checkboxPaddingRight);
});

exports.CheckboxWrapper = CheckboxWrapper;

var OptionWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), (0, _polished.ellipsis)());

exports.OptionWrapper = OptionWrapper;

var OptionCheckboxLayer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  ", ";\n"])), function (_ref10) {
  var isDisabled = _ref10.isDisabled;
  return !isDisabled && "cursor: pointer";
});

exports.OptionCheckboxLayer = OptionCheckboxLayer;

var MultiValueChip = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  margin-right: ", ";\n  position: relative;\n  border-radius: ", ";\n  padding: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  display: flex;\n  min-width: 20px;\n  ", "\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &:hover > svg {\n    fill: ", ";\n  }\n\n  &:hover > svg:hover {\n    fill: ", ";\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.multiValueChipBackgroundColor;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.multiValueChipTextColor;
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.multiValueChipFontSize);
}, function (_ref14) {
  var theme = _ref14.theme;
  return "".concat(theme.multiValueChipMarginRight);
}, function (_ref15) {
  var theme = _ref15.theme;
  return "".concat(theme.multiValueChipBorderRadius);
}, function (_ref16) {
  var theme = _ref16.theme,
      size = _ref16.size;
  return size === 'default' ? "".concat(theme.multiValueChipPaddingVerticalDefault) : "".concat(theme.multiValueChipPaddingVerticalSmall);
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.multiValueChipPaddingLeft);
}, function (_ref18) {
  var theme = _ref18.theme;
  return "".concat(theme.multiValueChipPaddingRight);
}, (0, _polished.ellipsis)(), function (_ref19) {
  var theme = _ref19.theme;
  return theme.multiValueChipHoveredBackgroundColor;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.multiValueChipHoveredTextColor;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.multiValueChipCloseIconChipHoveredColor;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.multiValueChipCloseIconHoveredColor;
});

exports.MultiValueChip = MultiValueChip;
var MultiValueChipCloseIcon = (0, _styledComponents["default"])(CloseIcon).attrs(function () {
  return {
    size: 20
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(50% - 10px);\n  right: 6px;\n  cursor: pointer;\n  fill: ", ";\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.multiValueChipCloseIconColor;
});
exports.MultiValueChipCloseIcon = MultiValueChipCloseIcon;

var ValueWrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex: 1;\n  flex-wrap: nowrap;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  word-wrap: normal;\n"])));

exports.ValueWrapper = ValueWrapper;

var ShortMultiDisplay = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-right: ", ";\n  ", "\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return "".concat(theme.shortMultiDisplayPadding);
}, (0, _polished.ellipsis)());

exports.ShortMultiDisplay = ShortMultiDisplay;